import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions/index";
import sampleCombine from 'xstream/extra/sampleCombine';
import { push } from 'react-router-redux'
import {reset} from "redux-form/immutable";

export function resetCriterionFormAfterCreate(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_CRITERION_SUCCESS)
    .map(action => reset('criterion'));

  return {
    ACTION: action$,
  }
}

export function redirectAfterCriterionDelete(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_CRITERION_SUCCESS)
    .map(action => (push('/criteria')));

  return {
    ACTION: action$
  }
}

export function requestDeleteCriterion(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_CRITERION)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/criteria/' + action.payload.id,
      category: 'requestDeleteCriterion',
      method: 'DELETE',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDeleteCriterion')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.deleteCriterionSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDeleteCriterionFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDeleteCriterion')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => actions.deleteCriterionFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function redirectAfterUpdateCriterionSuccess(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_CRITERION_SUCCESS)
    .map(action => push('/criteria'));

  return {
    ACTION: action$,
  }
}
export function requestUpdateCriterion(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_CRITERION)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/criteria/' + action.payload.id,
      category: 'requestUpdateCriterion',
      method: 'PATCH',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestUpdateCriterion')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.updateCriterionSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestUpdateCriterionFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestUpdateCriterion')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.updateCriterionFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCriterionById(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_CRITERION_BY_ID)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/criteria/' + action.payload.id,
      category: 'requestCriterionById',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCriterionById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getCriterionByIdSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCriterionByIdFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCriterionById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getCriterionByIdFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCreateCriterion(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_CRITERION)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/criteria',
      category: 'requestCreateCriterion',
      method: 'POST',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCreateCriterion')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.createCriterionSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCreateCriterionFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCreateCriterion')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.createCriterionFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/criterion.js